
import React from 'react';
import { useToken } from "./token_context";
import { useMessage } from "./message_context";
import { usePageContext } from "./page_context";
import { OKCancelDialog } from "./util/ok_cancel_dialog";



import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from "yup";


function make_random_token() {
    return Math.random().toString(36).substr(2) + Math.random().toString(36).substr(2) + Math.random().toString(36).substr(2);
};


async function upsertToken(access_token, data) {
    const payload = {
        _t: access_token.token,
        token: data.token,
        type: data.type,
        description: data.description,
        policies: data.policies
    };
    const res = await fetch("/api/model/tokens/" + data.token,
        {
          "method": "PUT",
          "body": JSON.stringify(payload)
        });
    const res_data = await res.json();
    return res_data.rc == "ok";
}

async function readToken(access_token, token) {
    const res = await fetch("/api/model/tokens/" + token + "?_t=" + access_token.token)
    const res_data = await res.json();
    if (res_data.rc == "ok") {
        return res_data.data
    } else {
        return null;
    };
};

async function deleteToken(access_token, token) {
    const res = await fetch("/api/model/tokens/" + token + "?_t=" + access_token.token, {
        method: "DELETE"
    })
    const res_data = await res.json();
    return res_data.rc == "ok";
};


export function TokenEditModal(props) {
    const { token } = useToken();
    const { setMessage } = useMessage();
    const {page_state, setPageState} = usePageContext();
    const [del_confirm_open, setDelConfirmOpen] = React.useState(false);

    if (!token.permissions.includes("can_admin_tokens")) return;


    var dialog_title;


    const initialValues = {
        token: "",
        type:"access_token",
        description:"",
        policies:""
    };

    const validationSchema = Yup.object({
      token: Yup.string().required("Required"),
      type: Yup.string().required("Required"),
      description: Yup.string().required("Required"),
      policies: Yup.string().required("Required"),
    });


    function onSubmit(values) {
        const ok = upsertToken(token, values);
        if (ok) {
            setPageState({
                admin_tokens_active: true,
                edit_token_dialog_open: false
            });
            if (page_state.edit_token_id) {
                setMessage("Token updated");
            } else {
                setMessage("Token created");
            };
        }
    };

    function handleDeleteToken() {
        deleteToken(token, page_state.edit_token_id).then(() => {
            setDelConfirmOpen(false);
            setPageState({
                admin_tokens_active: true,
                edit_token_dialog_open: false
            });
            setMessage("Token deleted");
        });
    };



    function onClick_Cancel(evt) {
        setPageState({
            admin_tokens_active: true,
            edit_token_dialog_open: false
        });
    };

    if (page_state.edit_token_dialog_open) {

        if (!page_state.edit_token_id) {
            dialog_title = "Add Access Token";
        } else {
            dialog_title = "Edit Access Token";
        };

        return (

    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
        {({ values, errors, touched, isSubmitting, setFieldValue }) => {
//            const [user, setUser] = React.useState({});
//            const [showPassword, setShowPassword] = React.useState(false);

            React.useEffect(() => {
                if (page_state.edit_token_id) {
                    readToken(token, page_state.edit_token_id).then((data) => {
                        setFieldValue("qrcode", data.qrcode, false);
                        setFieldValue("token", data.token, false);
                        setFieldValue("type", data.type, false);
                        setFieldValue("description", data.description, false);
                        setFieldValue("policies", data.policies, false);
                    });
                } else {
                    setFieldValue("token", make_random_token, false);
                };
/*                if (!true) {
                    // get user and set form fields
                    userService.getById(id).then(user => {
                        const fields = ['title', 'firstName', 'lastName', 'email', 'role'];
                        fields.forEach(field => setFieldValue(field, user[field], false));
                        setUser(user);
                    });
                } */
            }, []);


            return (

      <Form>
        <dialog {...props} id="token_edit_modal" className="modal" open>

              <div className="modal-box">
                <div className="modal-action flow-root">
                    <h3 className="font-bold text-lg py-2 float-left">{dialog_title}</h3>
                    <a href={'/show_qrcode/' + values.token} target="_blank">
                        <img className="float-right" width="100" src={values.qrcode} />
                    </a>
                </div>

              <div className="relative z-0 w-full mb-5 group">
                  <label htmlFor="token"
                         className="block mb-2.5 text-sm font-medium text-heading">
                         Token
                 </label>
                  <Field type="text"
                         name="token"
                         className="bg-neutral-secondary-medium border border-default-medium text-heading text-sm rounded-base focus:ring-brand focus:border-brand block w-full p-3.5 shadow-xs placeholder:text-body"
                         placeholder=" " />
                  <ErrorMessage name="token" component="div" className="text-red-600 font-bold" />
              </div>

             <label htmlFor="type" className="block mb-2.5 text-sm font-medium text-heading">Type</label>
              <Field name="type"
                     as="select"
                      className="block w-full px-3 py-2.5 bg-neutral-secondary-medium border border-default-medium text-heading text-sm rounded-base focus:ring-brand focus:border-brand shadow-xs placeholder:text-body">
                <option value="">Choose a type</option>
                <option value="access_token">Access Token</option>
              </Field>
              <ErrorMessage name="type" component="div" className="text-red-600 font-bold" />

            <div className="relative z-0 w-full mb-5 group">
                <label htmlFor="description" className="block mb-2.5 text-sm font-medium text-heading">Description</label>
                <Field as="textarea" name="description"
                          rows="4"
                          className="bg-neutral-secondary-medium border border-default-medium text-heading text-sm rounded-base focus:ring-brand focus:border-brand block w-full p-3.5 shadow-xs placeholder:text-body"
                          placeholder="Description...">
                </Field>
              <ErrorMessage name="description" component="div" className="text-red-600 font-bold" />
            </div>

            <div className="relative z-0 w-full mb-5 group">
                <label htmlFor="policies" className="block mb-2.5 text-sm font-medium text-heading">Policies</label>
                <Field as="textarea"
                          name="policies"
                          rows="2"
                          className="bg-neutral-secondary-medium border border-default-medium text-heading text-sm rounded-base focus:ring-brand focus:border-brand block w-full p-3.5 shadow-xs placeholder:text-body"
                          placeholder="attendee, display, orga, master">
                </Field>
              <ErrorMessage name="policies" component="div" className="text-red-600 font-bold" />
            </div>

                <div className="modal-action flow-root">
                    <button className="btn btn-cancel mx-2 float-left" onClick={onClick_Cancel} >Cancel</button>
                    <button className="btn btn-secondary mx-2 float-left" onClick={(e) => { e.preventDefault(); setDelConfirmOpen(true)} } >Delete</button>
                    {del_confirm_open && <OKCancelDialog open={del_confirm_open} title="Delete Token"
                                     content="Are you sure you want to delete this Token?"
                                     handleOK={() => {
                                         handleDeleteToken(token, page_state.edit_token_id);
                                     }}
                                     handleCancel={() => {
                                         setDelConfirmOpen(false);
                                     }}/>}
                    <button type="submit" className="btn btn-primary mx-2 float-right" >OK</button>
                </div>
              </div>
        </dialog>
      </Form>
    );}}
    </Formik>
    );
    }
};

